import {API} from "./config";
import {axiosClient, handleRequest} from "./axiosClient";
import {convertKeysToCamelCase, convertKeysToSnakeCase, filterObjectProperties, objectToQueryString} from "../utils";


export const getAllAddress = async (params) => {
    const queryString = objectToQueryString(params);
    const url = `${API.address.getAllAddress}?${queryString}`;
    const response = await handleRequest(axiosClient.get(url));
    const newResponse = {
        success: response?.success,
        status: response?.status,
        data: convertKeysToCamelCase(response?.data),
    }
    return {...newResponse};
}

export const getDetailAddress = async (id) => {
    const url = `${API.address.getDetailAddress.replace("{id}", id)}`;
    const response = await handleRequest(axiosClient.get(url));
    const newResponse = {
        success: response?.success,
        status: response?.status,
        data: convertKeysToCamelCase(response?.data),
    }
    return {...newResponse};
}
export const deleteAddress = (id) => {
    const url = `${API.address.deleteAddress.replace("{id}", id)}`;
    return handleRequest(axiosClient.delete(url));
}

export const updateAddress = (id, paramsUpdate) => {
    const url = `${API.address.updateAddress.replace("{id}", id)}`;
    const params = convertKeysToSnakeCase(filterObjectProperties(paramsUpdate))
    return handleRequest(axiosClient.patch(url, params));
}
export const createAddress = (paramsCreate) => {
    const url = `${API.address.createAddress}`;
    const params = convertKeysToSnakeCase(filterObjectProperties(paramsCreate))

    return handleRequest(axiosClient.post(url, params));
}